/* src/app/private/components/reports/ticket-report-details/ticket-report-details.component.scss */
/*# sourceMappingURL=ticket-report-details.component.css.map */
